import { DefaultTheme } from "styled-components/dist/types"

// These styles are general styles for flowable pages
export const getFlowablePageStyles = ({ theme }: { theme: DefaultTheme }): string => {
  return `
  .flw-externalApp.flw-externalApp--flow-app,
  .flw-customCaseDetails .flw-customCaseDetails__padding,
  .flw-customCaseDetails .flw-customCaseDetails__panel {
    padding: 0px;
  }
  .flw-externalApp.flw-externalApp--flow-app,
  .flw-formPage.flw-fullPageFormLayout,
  .flw-customCaseDetails,
  .flw-customCaseDetails .flw-customCaseDetails__padding,
  .flw-customCaseDetails .flw-customCaseDetails__panel,
  .flw-header-detail,
  .flw-header-detail__body,
  .flw-process-instance-details__panel,
  .flw-process-instance-details__body,
  .flw-taskDetails__body,
  .flw__panel {
    background-color: ${theme.color.general.background};
    box-shadow: none;
  }
  .flw-customCaseDetails__body {
    border: none;
  }
  .flw-tabs__head {
    display: none;
  }
  .flw-fullScreenPortal__container,
  .flw-root-app__loader,
  .flw-fullScreenPortal {
     display: none;
  }
  `
}